export default "/fonts/vendor/balm-ui/material-icons-outlined.woff2?c32fc86b5d23fdcfcd4d4e2dbd1b35a9";